import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';

import ProductDto from '@/application/dto/ProductDto';

import {
  Back,
  ProductDescription,
  ProductImage,
  ProductInfoContainer,
  ProductPrice,
} from './style';
import './style.css';
import Layout from '../Layout';

const MercadoPago = () => {
  const { companiesSlug } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!location.state || !location.state.product) {
      navigate(`/${companiesSlug}/products`);
    }
  }, [location, navigate]);

  const goBack = () => {
    if (location.pathname.includes('customer')) {
      navigate(`/${companiesSlug}/products`, { replace: true });
      return;
    }
    navigate(location.state?.from, {
      state: { ...location.state, from: location.pathname },
    });
  };

  if (!location.state || !location.state.product) {
    return null;
  }

  const product = location.state.product as ProductDto;

  return (
    <Layout>
      <div className="container">
        <Back onClick={goBack}>
          <span className="material-icons">arrow_back</span> Voltar
        </Back>

        <ProductInfoContainer className="row">
          <div className="col-4" style={{ paddingTop: '10px' }}>
            <ProductImage src={product.image} />
          </div>
          <div className="col-6">
            <h3>{product.name}</h3>
            <ProductDescription>{product.description}</ProductDescription>
            <ProductPrice>
              <div>
                <h4>de</h4>
                <h4>
                  {Intl.NumberFormat('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  }).format(product.pricePrevious || 0)}
                </h4>
              </div>
              <h2>
                por{' '}
                {Intl.NumberFormat('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                }).format(product.priceCurrent || 0)}
              </h2>
            </ProductPrice>
          </div>
        </ProductInfoContainer>

        <Outlet />
      </div>
    </Layout>
  );
};

export default MercadoPago;
